import { Link } from "react-router-dom";
import { Facebook, Instagram, ExternalLink } from "lucide-react";
import { ClubLogo } from "./ClubLogo";
import { ADDRESS, LINKS } from "../data/club";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#08101A]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3 mb-4">
          <ClubLogo size={44} />
          <div className="font-head font-extrabold leading-tight">
            Whitley Bay
            <span className="block text-[10px] font-mono-club uppercase tracking-[0.25em] text-[#E5AC3C]">Cricket Club</span>
          </div>
        </div>
        <p className="text-sm text-[#9BB0C1] leading-relaxed" data-testid="footer-address">
          {ADDRESS}
        </p>
        <p className="text-sm text-[#5C7285] mt-2">Cricket at West Park since 1960.</p>
        <div className="mt-5 inline-flex items-center gap-3 rounded-xl bg-white px-4 py-3" data-testid="footer-clubmark-badge">
          <img src="/assets/clubmark.jpg" alt="ECB Clubmark accreditation logo" className="h-9 w-auto" loading="lazy" />
          <span className="text-[10px] font-bold text-[#0B1520] uppercase tracking-[0.12em] leading-tight">ECB Clubmark<br />Accredited Club</span>
        </div>
      </div>

      <div>
        <h3 className="text-xs font-mono-club uppercase tracking-[0.2em] text-[#E5AC3C] mb-4">Explore</h3>
        <ul className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
          {[
            ["Teams", "/teams"],
            ["Fixtures", "/fixtures"],
            ["Honours", "/honours"],
            ["Social & Bar", "/social"],
            ["News", "/news"],
            ["Gallery", "/gallery"],
            ["Sponsorship", "/sponsorship"],
            ["Facility Booking", "/booking"],
            ["Contact Us", "/contact"],
          ].map(([label, path]) => (
            <li key={path}>
              <Link to={path} className="text-[#9BB0C1] hover:text-[#E5AC3C] transition-colors" data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="text-xs font-mono-club uppercase tracking-[0.2em] text-[#E5AC3C] mb-4">Follow the Club</h3>
        <div className="flex flex-col gap-3 text-sm">
          <a href={LINKS.facebook} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#9BB0C1] hover:text-[#E5AC3C] transition-colors" data-testid="footer-social-facebook">
            <Facebook size={16} /> Facebook
          </a>
          <a href={LINKS.instagram} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#9BB0C1] hover:text-[#E5AC3C] transition-colors" data-testid="footer-social-instagram">
            <Instagram size={16} /> Instagram
          </a>
          <a href={LINKS.playCricket} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#9BB0C1] hover:text-[#E5AC3C] transition-colors" data-testid="footer-social-playcricket">
            <ExternalLink size={16} /> Play-Cricket — fixtures & results
          </a>
        </div>
      </div>
    </div>
    <div className="border-t border-white/5">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-[#5C7285]">
        <span data-testid="footer-copyright">© 2026 Whitley Bay Cricket Club. All rights reserved.</span>
        <Link to="/admin" className="hover:text-[#9BB0C1] transition-colors" data-testid="footer-admin-link">Club Admin</Link>
      </div>
    </div>
  </footer>
);
